<template>
  <div class="mailList">
    <div class="mailListBox">
      <div class="mailListBox1">
        <div class="content">
          <div class="shenhe-btn" >
            <el-button class="conter-btn" type="primary" @click="toBack">返回</el-button>
          </div>
          <div class="title">{{data.title}}</div>
          <div class="content1 ql-editor" v-html="data.content"></div>
          <div class="img-list">
            <img v-for="(item,index) in imgList" :key="index" :src="item" alt="">
          </div>
        </div>
      </div>
      <div v-for="(item, index) in dataArr" :key="index" class="mailListBox1">
        <div class="textItem" v-if="item.user_identity === 1"><span>我</span>  <span>发送时间: {{item.create_time}}</span></div>
        <div class="textItem" v-if="item.user_identity === 2"><span>管理员 </span> <span>回复时间: {{item.create_time}}</span></div>
        <div class="content">
          <div class="content1 ql-editor" v-html="item.msg"></div>
        </div>
      </div>
      <div class="textItem" v-if="data.type === 3 || data.type === 4">回复:</div>
      <div class="textarea" v-if="data.type === 3 || data.type === 4">
        <el-input
          type="textarea"
          :rows="10"
          placeholder="请输入内容"
          v-model="textarea">
        </el-input>
      </div>
      <div class="btnList" v-if="data.type === 3 || data.type === 4">
        <el-button class="btn1" @click="tijiao">发送</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../../config/index'
  export default {
    data() {
      return {
        data: {}, // 页面数据
        textarea: '', // 文本域
        dataArr:[],
        imgList:[]
      }
    },
    created() {
      this.init()
    },
    methods: {
      init () {
        this.$api.apiMember.insidecont({
          userToken: this.$store.state.user.user_token,
          id: this.$route.params.id,
          type: this.$route.query.type
        }).then(res => {
          this.data = res.data
          res.data.wenda.map(item=>{
            item.create_time = this.$tools.ZHDate(new Date(item.create_time*1000),1)
          })
          this.dataArr = res.data.wenda
          if(res.data.appendix){
            let _arr = res.data.appendix.split(',')
            _arr.splice(0, 1)
            _arr.splice(_arr.length-1, 1)
            _arr.map(item =>{
              this.imgList.push(config.urlStr+'/' + item)
            })
          }
        }).catch(e => {
          console.log(e)
        })
      },
      toBack(){
        this.$router.go(-1)
      },
      // 回复信息
      tijiao () {
        if (this.textarea === '') {
          this.$message.error('请输入回复内容')
          return
        }
        this.$api.apiMember.replyinside({
          userToken: this.$store.state.user.user_token,
          id: this.data.id,
          msg: this.textarea,
          user_identity:1
        }).then(res => {
          console.log(res)
          this.$message({
            message: '回复成功',
            type: 'success'
          })
          this.init()
          this.textarea = ''
        }).catch(e => {
          console.log(e)
        })
      }
    },
    components: {
    },
  }
</script>

<style scoped lang="scss">
  .mailList {
    width: 100%;
    height: 100%;
    min-height: 600px;
    background: rgba(244, 246, 249, 1);
    overflow: hidden;
    .mailListBox {
      width: 1200px;
      min-height: 600px;
      margin: 43px auto 53px auto;
      .mailListBox1 {
        margin-bottom: 20px;
        .textItem {
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #999999;
          line-height: 20px;
        }
        .content {
          width: 1200px;
          min-height: 100px;
          padding: 20px;
          background: #ffffff;
          margin-top: 10px;
          .title {
            font-size: 16px;
            text-align: center;
            height: 30px;
          }
          .content {
            line-height: 20px;
          }
        }
      }
      .textItem {
        color: #999999;
        line-height: 20px;
      }
      .textarea {
        margin: 20px 0 19px 0;
      }
      .btnList {
        .btn1 {
          padding: 8px 36px;
          background-color: #00a2ea;
          color: #ffffff;
        }
      }
    }
    .img-list{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 20px 0;
      img{
        display: block;
        width: auto;
        max-width: 100%;
        margin: 0 auto;
      }
    }
  }

</style>